export default {
  zh: {
    booster: "加速器",
    index: "首页",
    help: "帮助",
    download: "下载",
    settings: "设置",
    invitationRecords: "邀请记录",
    topUpRecords: "充值记录",
    affiliate: "联盟推广",
    signIn: "登录",
    signUp: "快速注册",
    discount1: "立即节省",
    discount2: "%",
    signOut: "退出",
  },
  en: {
    booster: "VPN",
    index: "Home",
    help: "Help",
    download: "Download",
    settings: "Settings",
    invitationRecords: "Invitation Records",
    topUpRecords: "Consumption Records",
    affiliate: "Affiliate",
    signIn: "Sign In",
    discount1: "Get",
    discount2: "% Off",
    signUp: "Register",
    signOut: "Sign Out",
  },
};



// WEBPACK FOOTER //
// ./src/components/plexHeader/mainHeader/lang.js